import React, { useState } from 'react';
import { Accordion } from 'react-bootstrap';

interface AccordionItem {
    title: string;
    content?: string;
}

interface AccordionBlogProps {
    arrayData: AccordionItem[];
}

const AccordionBlog: React.FC<AccordionBlogProps> = ({arrayData}) => {
    const [activeKey, setActiveKey] = useState<string>('0');
    const brandColor = '#d89d37';

    return (
        <Accordion
            activeKey={activeKey}
            onSelect={(key) => setActiveKey(key as string)}
            style={{ marginTop: '38px' }}
        >
            {arrayData.map((item, ind)=>(
                <div
                    className="card"
                    key={ind}
                    style={{
                        background: '#ffffff',
                        boxShadow: '2px 2px 60px rgba(0,0,0,0.08)',
                        border: 'none',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        marginBottom: '20px',
                    }}
                >
                    <Accordion.Item eventKey={`${ind}`}>
                        <Accordion.Header
                            as="div"
                            style={{
                                padding: 0,
                                background: 'transparent',
                                border: 'none',
                                borderRadius: '8px',
                            }}
                        >
                            <div
                                style={{
                                    width: '100%',
                                    minHeight: '60px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    fontSize: '18px',
                                    lineHeight: '24px',
                                    padding: '15px 70px 15px 30px',
                                    position: 'relative',
                                    background: activeKey === `${ind}` ? brandColor : '#ffffff',
                                    color: activeKey === `${ind}` ? '#ffffff' : '#2c3d4f',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    fontWeight: activeKey === `${ind}` ? '600' : '500',
                                }}
                            >
                                {item.title}
                                <span
                                    className="arrow-icon"
                                    style={{
                                        position: 'absolute',
                                        top: '50%',
                                        right: '20px',
                                        transform: activeKey === `${ind}` ? 'translateY(-50%) rotate(-90deg)' : 'translateY(-50%) rotate(0deg)',
                                        width: '40px',
                                        height: '40px',
                                        background: activeKey === `${ind}` ? '#ffffff' : brandColor,
                                        borderRadius: '6px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        transition: 'all 0.3s ease',
                                    }}
                                >
                                    <i
                                        className="fa fa-angle-left"
                                        style={{
                                            color: activeKey === `${ind}` ? brandColor : '#ffffff',
                                            fontSize: '24px',
                                            transition: 'all 0.3s ease',
                                        }}
                                    />
                                </span>
                            </div>
                        </Accordion.Header>
                        <Accordion.Collapse eventKey={`${ind}`}>
                            <div
                                className="accordion-body"
                                style={{
                                    padding: '25px 30px',
                                    color: '#5a6c7d',
                                    fontSize: '16px',
                                    lineHeight: '1.8',
                                }}
                            >
                                <p style={{ marginBottom: 0 }}>{item.content}</p>
                            </div>
                        </Accordion.Collapse>
                    </Accordion.Item>
                </div>
            ))}
        </Accordion>
    );
};

export default AccordionBlog;